export type Coordinates = {
  latitude: number;
  longitude: number;
};

export async function getCurrentPosition(): Promise<Coordinates> {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    throw new Error('Location is not available in this browser. Use the mobile app on a phone with GPS enabled.');
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        const message =
          error.code === error.PERMISSION_DENIED
            ? 'Location permission denied. Allow location access to clock in at the office.'
            : error.code === error.POSITION_UNAVAILABLE
              ? 'Could not determine your location. Try again outdoors or near a window.'
              : error.code === error.TIMEOUT
                ? 'Location request timed out. Try again.'
                : error.message || 'Failed to get location';
        reject(new Error(message));
      },
      {
        enableHighAccuracy: true,
        timeout: 20_000,
        maximumAge: 5_000,
      }
    );
  });
}
